import drawerNav from "../class/drawerNav";

export default class customDrawerNav extends drawerNav {
  constructor(opt) {
    super(opt);
  }

  // 上書きするメソッドを記入
  
}